module.exports = __webpack_public_path__ + "img/7豪华双人海景房.fc5ccf7.jpg";